import { Injectable } from '@angular/core';
import { EstimationState } from 'src/app/models/EstimationState';

export interface DashboardFilters {
    selectedStates: EstimationState[];
    searchText: string;
    monthsFilter: string;
    sliderValue: number;
    searchInput: string;
}

@Injectable({
    providedIn: 'root'
})
export class DashboardFilterStateService {
    private filterState: DashboardFilters = {
        selectedStates: [],
        searchText: '',
        monthsFilter: '',
        sliderValue: 4,
        searchInput: ''
    };

    private hasStoredState: boolean = false;

    constructor() { }

    /**
     * Save current filter state
     */
    saveFilters(filters: DashboardFilters): void {
        this.filterState = {
            selectedStates: [...filters.selectedStates],
            searchText: filters.searchText,
            monthsFilter: filters.monthsFilter,
            sliderValue: filters.sliderValue,
            searchInput: filters.searchInput
        };
        this.hasStoredState = true;
    }

    /**
     * Get saved filter state
     */
    getFilters(): DashboardFilters {
        return {
            selectedStates: [...this.filterState.selectedStates],
            searchText: this.filterState.searchText,
            monthsFilter: this.filterState.monthsFilter,
            sliderValue: this.filterState.sliderValue,
            searchInput: this.filterState.searchInput
        };
    }

    /**
     * Check if there are saved filters
     */
    hasFilters(): boolean {
        return this.hasStoredState;
    }

    /**
     * Clear all saved filter state
     */
    clearFilters(): void {
        this.filterState = {
            selectedStates: [],
            searchText: '',
            monthsFilter: '',
            sliderValue: 4,
            searchInput: ''
        };
        this.hasStoredState = false;
    }
}
